import CustomFileUpload from 'app/components/CustomFileUpload';
import { Box, FormHelperText, Typography, useTheme } from '@mui/material';
import {
  UploadInfoBadge,
  UploadInfoBadgeText,
} from 'app/pages/anipay/new-payment/ui/assignment-details/file-upload/new-payment.file-upload.sx';
import { useFileUpload } from 'app/utils/services/transferService';
import { sanitizeFileName } from 'app/utils/file/sanitizeFileName';
import { FileRejection } from 'react-dropzone/.';
import { useFormContext } from 'react-hook-form';
import { FileObject, FormFieldValues } from 'app/pages/anipay/model/types';
import { useTranslation } from 'react-i18next';
import { i18n as i18Type, TFunction } from 'i18next';
import { enqueueSnackbar } from 'notistack';
import { useAniPayFileUpload } from 'app/pages/anipay/api/usePaymentFlow';

const documentsToBeDownloaded = (t: TFunction) => [
  {
    name: t('guarantee.tender_announcement'),
    id: 1,
  },
  {
    name: t('guarantee.founder_decision'),
    id: 2,
  },
  {
    name: t('guarantee.contract'),
    id: 3,
  },
];

const NewPaymentFileUpload = () => {
  const { t } = useTranslation();
  const {
    trigger,
    getValues,
    setValue,
    formState: { errors },
    setError,
  } = useFormContext<FormFieldValues>();
  const { isLoading, mutate, response } = useAniPayFileUpload();
  const downloadedFiles = getValues('files') as FileObject[];

  const setFilesToForm = (fileName: FileObject) => {
    setValue('files', [...(downloadedFiles ?? []), fileName], { shouldValidate: true });
  };

  const handleDeleteFile = (item: FileObject) => {
    const newFiles = downloadedFiles.filter((file) => file.file_id !== item.file_id);
    setValue('files', newFiles, { shouldValidate: true });
  };

  const onDrop = (acceptedFiles: File[], fileRejection: FileRejection[]) => {
    if (downloadedFiles && downloadedFiles.length === 10) {
      setError('files', { type: 'error', message: t('guarantee.uploadedMaxFileCount') });

      return;
    }
    try {
      const file = acceptedFiles[0];
      const sanitizedFileName = sanitizeFileName(file.name);
      const overratedFile: any = new File([file], sanitizedFileName, { type: file.type });

      if (fileRejection[0]?.errors[0].code === 'file-too-large') {
        setError('files', { type: 'error', message: t('guarantee.file_too_large') });
      } else {
        /*This log debugger ensures that for production env.*/
        const formData = new FormData();
        formData.append('files', overratedFile);

        mutate(formData, {
          onSuccess: (data) => {
            const { file_id, result } = data;
            console.log('overratedFile.name : ', overratedFile.name.length);

            if (file_id) {
              const fileObject = {
                name: overratedFile.name,
                size: overratedFile.size,
                file_id,
              };
              setFilesToForm(fileObject);
            }
          },
          onError: (error) => {
            setError('files', { type: 'error', message: t('guarantee.file_upload_error') });
          },
        });
      }
    } catch (error) {
      enqueueSnackbar('Something went wrong when uploading file', {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        variant: 'error',
      });
    }
  };

  return (
    <>
      <CustomFileUpload
        onDrop={onDrop}
        withOutDetails={false}
        file={downloadedFiles}
        deleteFile={handleDeleteFile}
        fileSize={'30 Mb'}
        isLoading={isLoading}
      />
      {errors.files && <FormHelperText sx={{ color: 'red' }}>{errors.files.message}</FormHelperText>}
    </>
  );
};

export default NewPaymentFileUpload;
